import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SafetySection() {
  const { t } = useTranslation();

  const safetyItems = [
    { icon: 'ri-link', text: t('safetyCheckUrl') },
    { icon: 'ri-lock-password-line', text: t('safetyProtectPassword') },
    { icon: 'ri-secure-payment-line', text: t('safetyVerifyPayment') },
    { icon: 'ri-camera-line', text: t('safetyReviewQC') },
    { icon: 'ri-truck-line', text: t('safetyCheckShipping') },
    { icon: 'ri-file-list-line', text: t('safetyKeepRecords') },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div className="rounded-2xl overflow-hidden shadow-lg order-2 md:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=Security%20safety%20digital%20protection%20shield%20lock%20concept%20on%20warm%20neutral%20background%20editorial%20photography%20clean%20minimal%20soft%20lighting%20aesthetic%20modern&width=800&height=600&seq=safety-img&orientation=landscape"
              alt="CSSBuy Safety"
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="order-1 md:order-2">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-5">
              {t('safetyH2')}
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-6 text-base">
              {t('safetyText')}
            </p>
            <div className="grid grid-cols-2 gap-3 mb-6">
              {safetyItems.map((item, index) => (
                <div key={index} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                    <i className={`${item.icon} text-accent-600`} style={{ width: 16, height: 16 }} />
                  </div>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
            <Link
              to="/cssbuy-safety"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('safetyCta')}
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}